<div class="sb-step sb-step-shipping-method">
  <form class="sb-step__form" [formGroup]="formGroup">

    <!-- region Step container -->
    <div class="sb-step__form__content">
      <div class="sb-step__inner-container">
        <div class="sb-form-block" formGroupName="shippingMethod">
          <div class="sb-form-block__title">
            {{'STEP.SHIPPING-METHOD.TITLE' | translate}}
          </div>
          <!-- region Shipping methods -->
          <div class="row radio-container wt-margin-bottom-2">
            <ng-container *ngFor="let shippingType of availableShippingTypes">
              <div class="col-xs-12 col-tb-6">
                <wt-input-radio groupName="shippingMethod-radio-group" [value]="shippingType.id" formControlName="method" [isHTML]="true">
                  <sb-display-input-radio [invalid]="isShippingMethodInvalid"
                                          [checked]="formGroup.get('shippingMethod.method').value === shippingType.id"
                                          [title]="shippingType.title"></sb-display-input-radio>
                </wt-input-radio>
              </div>
            </ng-container>
          </div>
          <!-- endregion -->
        </div>
      </div>
    </div>
    <!-- endregion -->
    <!-- region Buttons -->
    <section class="sb-step__form__footer">
      <sb-navigation-buttons [isSticky]="shouldBeSticky" (backClick)="goToPreviousStep()" (submitClick)="goToNextStep()"></sb-navigation-buttons>
    </section>
    <!-- endregion -->
  </form>
</div>
